import React from "react";
import { Collapse, Skeleton } from "antd";
import LinearDivider from "../../../components/LinearDividers";

function MarkerInfoCollapse({ title = "", loading = false, contents = [] }) {
  const { Panel } = Collapse;

  return (
    <div className="services">
      <Skeleton loading={loading} paragraph={false}>
        <>
          <div className="title">{title}</div>
          <LinearDivider width={"60%"} />
          {contents && contents.length
            ? contents.map((content, i) => {
                return (
                  <Collapse className={i > 0 ? "mt-3" : ""}>
                    <Panel header={content.fields[0]} key="2">
                      <p>{content.fields[1]}</p>
                    </Panel>
                  </Collapse>
                );
              })
            : ""}
        </>
      </Skeleton>
    </div>
  );
}

export default MarkerInfoCollapse;
